import { Text } from "@chakra-ui/react";

export default function Joys(){
    return(
        <>
        <Text className="text-format" style={{whiteSpace:"pre-line", alignContent:"center"}} >
        What brings you joy?
        <br/>
        <br/>
        can you find joy in failure, in errors and constraints?
        <br/>
        if not, what else can you make of those inevitable times?
        <br/>
        <br/>
        Practice making mistakes,
        <br/>compromises,
        <br/>that bring you closer to a goal.
        <br/>Compromises with yourself,
        <br/>that allow you to grow.
        <br/>
        <br/>Compromise is progress on your terms,
        <br/>in your ways.
        <br/>in your time.
        </Text>
        </>
    )
}